// AdminNavBar.jsx
import React from 'react';
import { useAuth } from '../../../AuthContext';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { Sidenav, Nav, Divider } from 'rsuite';
import infositeLogo from '../../../images/infosite-logo.png';
import infositeLogoSmall from '../../../images/infosite-logo-small.png';
import 'rsuite/dist/rsuite.css';

// Import icons from rsuite/icons
import DashboardIcon from '@rsuite/icons/Dashboard';
import FolderIcon from '@rsuite/icons/Folder';
import DocPassIcon from '@rsuite/icons/DocPass';
import TagIcon from '@rsuite/icons/Tag';
import ExitIcon from '@rsuite/icons/Exit';
import HelpOutlineIcon from '@rsuite/icons/HelpOutline';

function NavBar({ expanded, setExpanded }) { // Receive props
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Function to handle logout
  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // Function to determine the active path
  const getActiveKey = () => {
    if (location.pathname.startsWith('/admin/dashboard')) {
      return 'dashboard';
    }
    // Add more cases if needed
    return '';
  };

  const activeKey = getActiveKey();

  return (
    <div className="navbar-fixed">
      <Sidenav
        appearance="subtle"
        expanded={expanded} // Use expanded state to control the sidenav
        activeKey={activeKey}
        style={{ width: expanded ? 240 : 56, height: '100vh' }}
      >
        <Sidenav.Header>
          <div
            className="d-flex align-items-center justify-content-center text-center p-3 bg-dark"
            style={{ height: '50px', borderBottom: '1px solid #e5e5e5' }}
          >
            <h5 className="mb-0 text-white">
                {expanded ? (
                    <img src={infositeLogo} alt="Infosite Logo" style={{ height: '24px' }} />
                ) : (
                    <img src={infositeLogoSmall} alt="Infosite Logo" style={{ height: '24px' }} />
                )}
            </h5>
          </div>
        </Sidenav.Header>
        <Sidenav.Body>
          <Nav>
            {/* Dashboard Link */}
            <Nav.Item
              eventKey="dashboard"
              icon={<DashboardIcon />}
              as={Link}
              to="/admin/dashboard"
              active={location.pathname === '/admin/dashboard'}
            >
              {expanded && 'Översikt'}
            </Nav.Item>

            <Nav.Item
              eventKey="delticom"
              icon={<FolderIcon />}
              as={Link}
              to="/admin/delticom"
              active={(location.pathname.includes("/admin/delticom") || location.pathname.includes("/admin/order"))}
            >
              {expanded && 'Ordrar'}
            </Nav.Item>

            <Nav.Item
              eventKey="fakturor"
              icon={<DocPassIcon />}
              as={Link}
              to="/admin/fakturor"
              active={location.pathname === '/admin/fakturor'}
            >
              {expanded && 'Fakturor'}
            </Nav.Item>

            <Nav.Item
              eventKey="priser"
              icon={<TagIcon />}
              as={Link}
              to="/admin/priser"
              active={location.pathname === '/admin/priser'}
            >
              {expanded && 'Prisfilter'}
            </Nav.Item>
          </Nav>
        </Sidenav.Body>
        <div className='mt-auto'>
        <Nav className='mb-0'>
            <Nav.Item 
            eventKey="help"
            active={location.pathname === '/admin/help'} 
            icon={<HelpOutlineIcon />}
            as={Link}
            to="/admin/help"
            >{expanded && 'Hur gör jag?'}</Nav.Item>
            <Nav.Item onClick={logout} icon={<ExitIcon style={{ color: "red" }} />}>{expanded && 'Logga ut'}</Nav.Item>
        </Nav>
        </div>
        {/* Toggle Button */}
        <Sidenav.Toggle className='mt-0' onToggle={() => setExpanded(!expanded)} />
      </Sidenav>
    </div>
  );
}

export default NavBar;
